import { useNavigate } from "react-router-dom";
import { expeditionRoutes } from "../../../../../router/routesConstants";
import { BinsVolumeDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";

function BinsVolumeActionButtons({
  itemId,
}: {
  itemId: string;
  crudData: BinsVolumeDataInterface;
}) {
  const navigate = useNavigate();

  const handleShowBins = () => {
    if (itemId) {
      navigate(`${itemId}/${expeditionRoutes.showBins}`);
    }
  };

  return (
    <ActionMenu
      items={[
        {
          id: "view-bins",
          label: "Vezi binuri",
          icon: "PACKAGES",
          tooltip: itemId
            ? "Afiseaza binurile din acest volum."
            : "Volumul trebuie sa aiba un identificator pentru a afisa binurile.",
          disabled: !itemId,
          onClick: handleShowBins,
        },
      ]}
      minItemsForMenu={2}
      title={`Volum ${itemId}`}
      ariaLabel={`Actiuni pentru volumul ${itemId}`}
    />
  );
}

export default BinsVolumeActionButtons;
